export default "__VITE_ASSET__DDiSynbl__"